/**
 * 选择数量组件
 * @author oubu
 */
import React, { Component } from 'react';
import { Flex, Button, Icon } from 'antd-mobile';
import cx from 'classnames';
import PropTypes from 'prop-types';
import './index.less';

export default class Stepper extends Component {
  static propTypes = {
    value: PropTypes.any, // 当前值,
    min: PropTypes.number, // 最小值
    max: PropTypes.number, // 最大值
    allowDel: PropTypes.bool, // 是否支持删完
    theme: PropTypes.oneOf(['basic', 'red']), // 主题 默认为basic
    buttonClass: PropTypes.string, // 加减区域外部样式类
    inputClass: PropTypes.string, // 当前值区域外部样式类
    onChange: PropTypes.func, // onChange事件
    requestChange: PropTypes.func // requestChange事件
  };

  static defaultProps = {
    value: '',
    min: 0,
    max: 9999,
    theme: 'basic',
    onChange: null,
    allowDel: false, // 是否支持向下删除 要配合步进器改版逻辑一起使用 原本的min应该改为minNumber || 1
    buttonClass: '',
    inputClass: '',
    requestChange: () => {}
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      value: props.value,
      disabled: props.disabled,
      theme: ['basic', 'red'].includes(props.theme) ? props.theme : 'basic',
      // 步进器风格：'empty': 镂空的样式，'full'：实心的样式
      style: props.showStyle || 'empty',
      minusDisable: !props.allowDel ? props.value <= props.min : false,
      plusDisable: props.value >= props.max
    };
  }

  componentWillReceiveProps(nextProps) {
    const { value, min, max } = this.state;
    const { value: nextVal, min: nextMin, max: nextMax } = nextProps;
    if (nextVal !== value || nextMin !== min || nextMax !== max) {
      this.setState({
        value: `${nextVal}`,
        plusDisable: +nextVal >= nextMax,
        minusDisable: !nextProps.allowDel ? +nextVal <= nextMin : false
      });
    }
    if (this.state.disabled !== nextProps.disabled) {
      this.setState({ disabled: nextProps.disabled });
    }
  }

  /**
   * 更改input的value
   * @param value
   */
  onChange = (value) => {
    this.props.onChange && this.props.onChange(value);
  };

  /**
   * input变化监听函数
   * @param event
   */
  inputOnChange = (event) => {
    event.stopPropagation();
    let val = event.target.value;
    const { min, max } = this.props;
    if (val > max) {
      val = max;
    }
    // 如果支持向下删除 那新版逻辑中，步进器中的值可以支持随意修改，
    // 值管理交给组件来控制，并在onBlur时再重新触发父组件onChange事件
    if (!this.props.allowDel) {
      this.props.inputChange && this.props.inputChange(val);
      this.onChange(val);
    } else {
      if (/^[0-9]*$/.test(val)) {
        this.setState({
          value: val !== '' ? Number(val) : val
        });
      } else {
        this.setState({
          value: ''
        });
      }
    }
  };

  /**
   * input focus变化监听函数
   * @param e
   */
  inputOnFocus = () => {
    this.tempValue = this.state.value;
    this.props.inputFocus && this.props.inputFocus();
  };

  /**
   * input blur变化监听函数
   * @param e
   */
  inputOnBlur = () => {
    if (this.tempValue !== this.state.value) {
      let value = this.state.value;
      if (this.state.value === '') {
        // 如果最后离开监听时的值为空字符串，使用focus时的记录值替代
        value = this.props.min;
      } else {
        value = +this.state.value;
        if (value >= this.props.max) {
          // 如果最后离开监听的值超过了最大值，那用最大值替代
          value = this.props.max;
        }
        if (value <= this.props.min) {
          // 如果最后离开监听的值低于最小值，那用最小值替代
          value = this.props.min;
        }
      }
      // 特殊处理 如果输入的就是0，那失去焦点时
      // 要额外触发一次父组件的onChange事件来触发删除动作
      if (this.state.value == 0 && this.state.value !== '') {
        this.onChange(Number(this.state.value));
      }
      this.onChange(value);
      this.props.requestChange(value);
    }
  };

  /**
   * +号点击事件
   * @param event
   */
  add = (event) => {
    const { disabled, plusDisable } = this.state;
    if (disabled || plusDisable) return;
    event.stopPropagation();
    const value = +this.state.value + 1;
    this.onChange(value);
    this.props.requestChange(value, 1);
  };

  /**
   * -号点击事件
   * @param event
   */
  sub = (event) => {
    const { disabled, minusDisable } = this.state;
    if (disabled || minusDisable) return;
    event.stopPropagation();
    const value = +this.state.value - 1;
    this.onChange(value);
    this.props.requestChange(value, 2);
  };

  render() {
    const { disabled, style, theme, minusDisable, plusDisable } = this.state;
    const { className, buttonClass, inputClass, callback, disabledInput } = this.props;
    return (
      <Flex
        className={cx(
          {
            'stepper-widget': theme == 'basic',
            'stepper-widget-red': theme == 'red'
          },
          style,
          className,
          { disabled }
        )}
        align="center"
        justify="center">
        <div style={{ position: 'relative' }}>
          <Button
            className={cx('btn', 'btn-stepper', 'sub-btn', buttonClass)}
            disabled={minusDisable || disabled}>
            <span className="iconfont icon-sami-select" />
          </Button>
          <div className="btn-container" onClick={this.sub} />
        </div>
        <input
          className={cx(inputClass)}
          type="number"
          value={this.state.value}
          onChange={this.inputOnChange.bind(this)}
          onClick={(e) => {
            e.stopPropagation();
            callback && callback();
          }}
          onBlur={() => this.inputOnBlur()}
          onFocus={() => this.inputOnFocus()}
          readOnly={disabledInput ? disabledInput : disabled}
        />
        <div style={{ position: 'relative' }}>
          <Button
            className={cx('btn', 'btn-stepper', 'add-btn', buttonClass)}
            disabled={plusDisable || disabled}>
            <span className="iconfont icon-add-select" />
          </Button>
          <div className="btn-container add-btn-container" onClick={this.add} />
        </div>
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/Stepper/index.js